<p>inventory-stock-by-date works!</p>
